import React from 'react';
import cn from 'classnames';
import pt from 'prop-types';
import styles from '../index.module.css';

const PersonButton = ({ data, darkTheme, isDisabled, isSelected, onClick }) => {
  const { email, firstname, lastname, image: dpURL } = data;
  const name = firstname ? `${firstname.trim()} ${(lastname || '').trim()}`.trim() : null;
  // A typed email that isn't a registered user comes through with no name. Promote
  // the email to the primary line instead of rendering an empty name row above it.
  const primary = name || email;
  const secondary = name ? email : null;
  const firstLetter = (primary || '').charAt(0).toUpperCase();
  const rowClassName = cn({
    [styles.personButton]: true,
    [styles.selected]: isSelected,
    // The autocomplete dropdown is portalled out of the dialog, so the dark
    // variant can't be inherited by a descendant selector — it is opted into
    // per-row instead.
    [styles.personButtonDark]: darkTheme,
  });
  return (
    <button
      className={rowClassName}
      disabled={isDisabled}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !isDisabled && onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className={styles.personButtonDP}>
        {dpURL
          ? <img alt={`person - ${primary}`} className={styles.personDPImage} src={dpURL} />
          : <div className={styles.personDPText}>{firstLetter}</div>}
      </div>
      <div className={styles.personButtonTextContent}>
        <div className={styles.personButtonName}>{primary}</div>
        {secondary && <div className={styles.personButtonEmail}>{secondary}</div>}
      </div>
    </button>
  );
};

PersonButton.defaultProps = {
  darkTheme: false,
  isDisabled: false,
  isSelected: false,
  onClick: undefined,
};

PersonButton.propTypes = {
  data: pt.object.isRequired,
  darkTheme: pt.bool,
  isDisabled: pt.bool,
  isSelected: pt.bool,
  onClick: pt.func,
};
export default PersonButton;
